<template>
	<v-layout row wrap justify-end class="section-banner" id="section-banner">
		<v-flex xs12>
			<v-layout wrap class="container">
				<v-flex xs12 md6></v-flex>
				<v-flex xs12 md6 class="section-banner-right">
					<v-layout row wrap align-center>
						<v-flex xs12 success--text>
							<h2 class="section-banner-title">
								¿Cuál es el costo de ser parte de <span class="text-bold">CASAMARKET?</span>
							</h2>
						</v-flex>
						<v-flex xs12 white--text>
							<h3 class="section-banner-subtitle">
								Ten tu propia app de pedidos con una mínima inversión
							</h3>
						</v-flex>
						<!-- <v-flex xs12 white--text class="section-banner-list">
							<v-layout
								class="section-banner-item"
								row wrap align-start
								v-for="(item, index) in list"
								:key="index"
							>
								<v-flex xs2 sm1>
									<img src="/static/images/icons/icon-check-CM.svg" alt="viñeta de texto" height="29">
								</v-flex>
								<v-flex xs10 sm11>
									{{ item }}
								</v-flex>
							</v-layout>
						</v-flex> -->
						<v-flex xs12 class="btn-container">
							<a :href="link" target="_blank" class="text-decoration-none">
								<v-btn
									class="btn-action btn-auto section-banner-btn"
									depressed
								>
									Ten Tu Propia App de Pedidos desde {{ numberMoney }}
								</v-btn>
							</a>
						</v-flex>
						<v-flex xs12 mt-3>
							<p class="mb-0 sub-text">Nuestra promoción incluye un regalo de S/300
								para que tus primeros pedidos sean gratis.</p>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>

function data() {
	return {
		list: [
			'Promoción de lanzamiento. Pago único para implementación',
		],
	};
}

export default {
	name: 'section-banner',
	data,
	props: {
		link: [String],
		numberMoney: String,
		discountMoney: String,
	},
};
</script>

<style lang="scss" scoped>
	.section-banner {
		background-image: url('/static/images/banners/banner-cost-mobile-CM.png');
		background-position: bottom;
		background-repeat: no-repeat;
		background-size: cover;
		height: 590px;
		padding-top: 164px;

		@media (min-width: 1024px) {
			background-image: url('/static/images/banners/banner-section-CM.png');
			background-position: center;
			height: auto;
			padding-top: 0px;
		}

		&-right {
			padding: 0px 2% 73px;

			@media (min-width: 360px) {
				padding: 0px 5% 73px;
			}

			@media (min-width: 768px) {
				padding: 0px 8% 73px;
			}

			@media (min-width: 1024px) {
				padding: 40px 0px;
			}
		}

		&-btn {
			background-color: color(primary-cs) !important;
			border-radius: 8px;
			color: color(white);
			font-size: size(medium16);
			font-weight: weight(w900);
			height: 91px !important;
			width: 100% !important;

			@media (min-width: 1024px) {
				height: 60px !important;
			}
		}

		&-title {
			color: color(primary) !important;
			font-size: size(large25);
			font-weight: weight(w600);
			margin: 0px 2%;
			text-align: center;

			@media (min-width: 360px) {
				margin: 0px 4%;
			}

			@media (min-width: 1024px) {
				font-size: size(large30);
				margin: 0px;
			}

			.text-bold {
				font-size: size(large32);
				font-weight: weight(w900);
				text-transform: uppercase;

				@media (min-width: 1024px) {
					font-size: size(large30);
				}
			}
		}

		&-subtitle {
			color: color(info);
			font-size: size(medium18);
			margin: 38px auto 36px;
			text-align: center;

			@media (min-width: 1024px) {
				margin: 25px auto 28px;
			}
		}

		&-list {
			padding: 0px 2%;

			@media (min-width: 1024px) {
				padding: 0px 4%;
			}

			@media (min-width: 1280px) {
				padding: 0px 8%;
			}

			@media (min-width: 1400px) {
				padding: 0px 14%;
			}
		}

		&-item {
			color: color(info-black);
			font-size: size(large25);
			font-weight: weight(w600);
			margin-bottom: 30px;

			@media (min-width: 1024px) {
				margin-bottom: 24px;
			}
		}
	}

	.text-decoration-none {
		text-decoration: none;
	}
	
	.btn-container {
		padding: 0px 2% 0px;

		@media (min-width: 1024px) {
			padding: 2px 4% 0px;
		}

		@media (min-width: 1280px) {
			padding: 2px 8% 0px;
		}

		@media (min-width: 1400px) {
			padding: 2px 14% 0px;
		}
	}

	.section-banner-title {
		color: color(success);
	}

	.sub-text {
		color: color(primary);
		text-align: center;

		@media (min-width: 1024px) {
			padding: 0px 20%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-banner.vue